import { render, staticRenderFns } from "./loadingCourses.vue?vue&type=template&id=56ecbd14&scoped=true"
import script from "./loadingCourses.vue?vue&type=script&lang=js"
export * from "./loadingCourses.vue?vue&type=script&lang=js"
import style0 from "./loadingCourses.vue?vue&type=style&index=0&id=56ecbd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ecbd14",
  null
  
)

export default component.exports